<template>
  <v-row>
    <v-col>
      <h1>Доставка</h1>
      <v-tabs v-model="tab">
        <v-tab v-for="(item, index) in tabs" :key="index">{{ item.label }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(item, index) in tabs" :key="index">
          <component :is="item.component" v-if="item.component"></component>
          <template v-if="item.settings && Object.keys(settings).length">
            <v-checkbox v-for="(field, key) in checkboxes" :key="key" v-model="settings[key].value" :label="field.label" @click="updateSetting(key)"></v-checkbox>
            <v-row>
              <v-col cols="4">
                <v-text-field v-for="(field, key) in textFields" :key="key" :label="field.label" v-model="settings[key].value" @blur="updateSetting(key)"></v-text-field>
              </v-col>
            </v-row>
          </template>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import Areas from './Area/Index';
import Streets from './Street/Index';
import Workshops from './Workshop/Index';
import Branches from './Branch/Index';
import OrderType from './OrderType/Index';
import Settlements from './Settlement/Index';
import SettingService from './../../api/SettingService';

export default {
  name: 'DeliveryIndex',
  data: () => ({
    tab: 1,
    settings: {},
    checkboxes: {
      is_mobile_order_direct: { label: 'Заказы с мобилки напрямую' },
      is_off_time_selects: { label: 'Выключить выбор доставки на точное время' },
      is_disabled_go_out: { label: 'Выключить Выйти к машине' },
      is_disabled_np: { label: 'Выключить Новую Почту' }
    },
    textFields: {
      max_delivery_time: { label: 'Максимальное время доставки до отделения' },
      delivery_cost: { label: 'Цена доставки' },
      np_min_sum: { label: 'Минимальная сумма для заказа через НП' },
      np_time: { label: 'Час, до которого отправка в этот же день' },
      np_small_box: { label: 'Маленькая коробка, объем' },
      np_medium_box: { label: 'Средняя коробка, объем' },
      np_large_box: { label: 'Большая коробка, объем' }
    },
    tabs: [
      // { label: 'Районы', component: 'areas' },
      // { label: 'Улицы', component: 'streets' },
      // { label: 'Филиалы', component: 'branches' },
      // { label: 'Цеха', component: 'workshops' },
      { label: 'Настройки', settings: true },
      { label: 'Типы заказов', component: 'order-type' },
      { label: 'Новая Почта (Населенные пункты)', component: 'settlements' }
    ]
  }),
  components: { Areas, Streets, Branches, Workshops, OrderType, Settlements },
  mounted() {
    [...Object.keys(this.checkboxes), ...Object.keys(this.textFields)].forEach((key) => {
      SettingService.get(key).then(response => {
        this.settings[key] = response.data;
        if (this.settings[key].value === 'true' || this.settings[key].value === 'false') {
          this.settings[key].value = this.settings[key].value === 'true';
        }
      });
    });
  },
  methods: {
    updateSetting(key) {
      SettingService.update(this.settings[key].id, { value: this.settings[key].value });
    }
  }
};
</script>
